import { render, staticRenderFns } from "./NColorPicker.vue?vue&type=template&id=524cc81e&scoped=true&"
import script from "./NColorPicker.vue?vue&type=script&lang=js&"
export * from "./NColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./NColorPicker.vue?vue&type=style&index=0&id=524cc81e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524cc81e",
  null
  
)

export default component.exports